/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ProdSheetFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const prodSheetFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodSheetFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const prodSheetFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const prodSheetFServ01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const prodSheetFServ01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const prodSheetFServ01FetchProdSheetFServ01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodSheetFServ01FetchProdSheetFServ01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prodSheetFServ01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prodSheetFServ01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prodSheetFServ01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prodSheetFServ01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_SHOW_SYNC_SETTING_LOADING]: prodSheetFServ01ShowSyncSettingLoading,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: prodSheetFServ01ShowSyncSettingSuccess,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: prodSheetFServ01ShowBatchJobStatusSuccess,

  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_RESET_TIMESTAMP]: prodSheetFServ01ResetTimestamp,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_FETCH_PROD_SHEET_F_SERV01_LOADING]: prodSheetFServ01FetchProdSheetFServ01Loading,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_FETCH_PROD_SHEET_F_SERV01_SUCCESS]: prodSheetFServ01FetchProdSheetFServ01Success,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_ADD_SELECTED_DOCUMENTS]: prodSheetFServ01AddSelectedDocuments,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_REMOVE_SELECTED_DOCUMENTS]: prodSheetFServ01RemoveSelectedDocuments,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_SET_WORKSPACE_VISIBLE]: prodSheetFServ01SetWorkspaceVisible,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_EXPORT_LOADING]: prodSheetFServ01ExportLoading,
  [ProdSheetFServ01Types.PROD_SHEET_F_SERV01_EXPORT_SUCCESS]: prodSheetFServ01ExportSuccess
});
